import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import useURLs from '@api/hooks/useURLs';

const CLX = styled.iframe`
  position: fixed;
  top: 0px;
  width: 100vw;
  height: 100vh;
  bottom: 0px;
  left: 0px;
  z-index: 3;
`;

const Iframe = ({
  files,
  removeFile,
  finishUpload,
  id,
  mode,
  file,
  setMode,
  goalUID,
  topicGroups,
  isEducator
}) => {
  const accessToken = useSelector(({ auth }) => auth.accessToken);
  const url = useURLs((urls) => urls.educatorDriveUrl);
  const driveDetails = useSelector(({ templates }) =>
    isEducator ? file : templates.addEditTemplate.driveDetails
  );
  const [isLoaded, setIsLoaded] = useState(false);

  const handleWidgetsVisibility = (visible) => {
    const fwVisible = visible ? 'show' : 'hide';
    const intercomVisible = !visible;
    window.FreshworksWidget?.(fwVisible);
    window.Intercom?.('update', {
      ...window.intercomSettings,
      hide_default_launcher: intercomVisible
    });
  };

  const onMessageReceived = (e) => {
    if (e.data.liveClassReady) {
      handleWidgetsVisibility(false);
      const message = {
        accessToken,
        apiHost: process.env.BACKEND_URL.slice(0, -1),
        parentUID: driveDetails.uid,
        isCloud: true,
        mode,
        files,
        fileInfo: file,
        isTemplateCreation: true
      };
      if (mode === 'edit')
        message.contentTaggingData = {
          isEnabled: true,
          topicGroups,
          goalUid: goalUID
        };
      document
        .getElementById('driveIframe')
        ?.contentWindow?.postMessage(message, '*');
    }
    if (e.data.closeIframe) {
      handleWidgetsVisibility(true);
      setMode?.('upload');
      if (e.data.files[0]) finishUpload?.(id, e.data.files[0]);
      removeFile?.();
    }
  };
  useEffect(() => {
    if (!isLoaded) setIsLoaded(true);
    window.addEventListener('message', onMessageReceived);
    return () => {
      window.removeEventListener('message', onMessageReceived);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!isLoaded) return null;

  return (
    <CLX
      src={url}
      title="iframe"
      id="driveIframe"
      webkitallowfullscreen="true"
      allowFullScreen
      width="100%"
      height="100%"
      frameBorder="no"
    />
  );
};

export default Iframe;

Iframe.propTypes = {
  setMode: PropTypes.func.isRequired,
  removeFile: PropTypes.func.isRequired,
  finishUpload: PropTypes.func.isRequired,
  files: PropTypes.arrayOf(PropTypes.any),
  mode: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  file: PropTypes.objectOf(PropTypes.any),
  goalUID: PropTypes.string,
  topicGroups: PropTypes.string,
  isEducator: PropTypes.bool
};

Iframe.defaultProps = {
  files: null,
  file: null,
  goalUID: '',
  topicGroups: '',
  isEducator: false
};
